import { createActionGroup, props } from '@ngrx/store';

import { HelpfulPermissionsStateModel } from './helpful-permissions-state.model';

export const HelpfulPermissionsActions = createActionGroup({
  source: 'HelpfulPermissions',
  events: {
    Init: props<HelpfulPermissionsStateModel>(),
  },
});
